import React from 'react';
import { Box, Text } from '@skin-seoul/design-system';
import { CLASSNAME } from '@skin-seoul/service';
import { SafeLink } from '@/components/ui/SafeLink';
import { type TaxonomyCategory } from '../utils/categoryUtils';
import CategoryImage from './CategoryImage';
interface CategoryCardProps {
  category: TaxonomyCategory;
  isActive: boolean;
  href: string;
}
const CategoryCard = ({
  category,
  isActive,
  href
}: CategoryCardProps) => {
  const hasThumbnail = Boolean(category.thumbnailImageUrl);
  return <SafeLink href={href} unstyled data-sentry-element="SafeLink" data-sentry-component="CategoryCard" data-sentry-source-file="CategoryCard.tsx">
      <Box width="108px" height="108px" borderRadius="50%" backgroundColor="generic.0" display="flex" flexFlow="column" alignItems="center" justifyContent="center" gap={hasThumbnail ? 2 : 0} _hover={{
      backgroundColor: 'primary.75'
    }} padding={3} cursor="pointer" transition="background-color 0.2s" data-sentry-element="Box" data-sentry-source-file="CategoryCard.tsx">
        {hasThumbnail && <Box height="48px" width="48px" display="flex" alignItems="center" justifyContent="center" overflow="hidden" mixBlendMode="multiply">
            <CategoryImage category={category} />
          </Box>}
        <Text textStyle="label.small" color={isActive ? 'primary.600' : 'neutral.600'} fontWeight="regular" textAlign="center" maxWidth="108px" textWrap="wrap" className={CLASSNAME.NOT_TRANSLATE} transition="color 0.2s" data-sentry-element="Text" data-sentry-source-file="CategoryCard.tsx">
          {category.name}
        </Text>
      </Box>
    </SafeLink>;
};
export default CategoryCard;